import Mapbox from "mapbox-gl";

function latLngFor(item: {
  lat: Number | string;
  lng: Number | string;
}): [number, number] {
  return [Number(item.lng), Number(item.lat)];
}

export function boundsFor(
  items: { lat: Number | string; lng: Number | string }[]
): Mapbox.LngLatBounds {
  const bounds = new Mapbox.LngLatBounds([
    latLngFor(items[0]),
    latLngFor(items[0]),
  ]);

  for (let i = 1; i < items.length; i++) {
    bounds.extend(latLngFor(items[i]));
  }

  return bounds;
}
